import { api } from "common";

export const DOCTORS_URL = {
	getDoctors:`${api.withAPI}api/doctor`,
	getDoctor: `${api.withAPI}api/doctor`,
	updateDoctor: `${api.withAPI}api/doctor`,
	getFeedbacksDoctor: `${api.withAPI}api/feedback`,
	createDoctor: `${api.withAPI}api/doctor`,
	deleteFeedback: `${api.withAPI}api/feedback`
}